import {defineStore} from 'pinia'

export const BltSidenavStore = defineStore("BltSidenavStore", {
  state: () => ({
    sidenavOpen: false
  }),
  actions: {
    toggleSidenav() {
    }
  }
})
